export const LOADING_SHIPPING_AREAS = "LOADING_SHIPPING_AREAS";
export const SET_SHIPPING_AREAS = "SET_SHIPPING_AREAS";
